import { render } from "./Register.vue?vue&type=template&id=7f464125&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=7f464125&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f464125"

export default script